import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Accordion, AccordionDetails, AccordionSummary } from 'base-ui'

export const DisclaimerAccordion: FC = () => {
  return (
    <Accordion className="not-prose mt-4">
      <AccordionSummary className="text-xl font-medium">
        <FormattedMessage id="prescriptionModal.faq.headline" />
      </AccordionSummary>
      <AccordionDetails className="bg-light-primary-medium text-s">
        <p>
          <FormattedMessage id="prescriptionModal.faq.message.1" />
        </p>
        <p className="mt-2">
          <FormattedMessage id="prescriptionModal.faq.message.2" />
        </p>
      </AccordionDetails>
    </Accordion>
  )
}
